import {Component, EventEmitter, Input, Output} from '@angular/core';
import {NotificationHandler} from '../../helper/notification.handler';
import {MatSelectChange} from '@angular/material/select';
import {Role} from '../../model/auth/Role';
import {Contest} from '../../model/contest/Contest';
import {ContestService} from '../../service/contest.service';
import {PaymentStatus} from '../../model/Payment';

@Component({
  selector: 'contest-select',
  templateUrl: './contest-select.component.html',
  styleUrls: ['./contest-select.component.scss']
})
export class ContestSelectComponent {

  readonly roles = [Role.Admin, Role.Host, Role.Coordinator, Role.Teacher, Role.Student];

  @Input() competitionId!: string;

  @Input() disabled = false;

  @Input() autoSelect = false;

  @Output() selected = new EventEmitter<Contest>();

  contests!: Contest[] | null;
  selectedValue?: Contest;

  constructor(private contestService: ContestService) {
  }

  initContent() {
    this.loadContests();
  }

  compareWith(c1: Contest, c2: Contest) {
    return c1 && c2 && c1.id === c2.id;
  }

  private loadContests() {
    this.contests = null;

    this.contestService.getContests(this.competitionId).subscribe(contests => {
      this.contests = contests.filter(contest => !contest.paymentStatus || contest.paymentStatus == PaymentStatus.successful);

      this.checkAutoSelect(contests);
    }, error => NotificationHandler.handleError($localize`:Notifications|Contests fetch has failed message@@notifications-contests-fetch-failed-error:Contests fetch has failed`, error));
  }

  private checkAutoSelect(contests?: Contest[]) {
    if (!this.selectedValue && this.autoSelect) {
      if (contests && contests.length > 0) {
        this.selectedValue = contests[0];
      }
    }

    this.disabled = !contests || !contests.length;
  }

  contestSelected(change: MatSelectChange) {
    const contest = change.value as Contest;

    this.selected.emit(contest);
  }

}
